import type { Prefab } from "../prefab";
import { buildPrefab } from "./prefabBuilder";
import { bigContainerData } from "./generalPrefabData";

export function getBigContainerPrefab(): Prefab {
	return buildPrefab(bigContainerData);
}
